import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone'
})
export class PhonePipe implements PipeTransform {

    transform(value: any, args?: any): any {
        if (!value) {
            return "No Phone Entered";
        }

        let emptyValue = "N/A";
        if (args != null && args != undefined && typeof args == "string") {
            emptyValue = args;
        }

        return `
          ${(value.phoneType && value.phoneType.description) ? value.phoneType.description : emptyValue}${((value.phoneType && value.phoneType.description) || emptyValue) ? ',' : ''} 
          ${value.number || emptyValue}${value.extensionNumber ? ' ext ' + value.extensionNumber : ''}${(value.phoneNumberNote || emptyValue) ? ',' : ''} 
          ${value.phoneNumberNote || emptyValue}
        `;
    }

}
